import { useEffect, useState } from 'react';

type ShortlistSheetState = {
  isOpen: boolean;
};

let state: ShortlistSheetState = { isOpen: false };
const listeners = new Set<() => void>();

const emitChange = () => {
  listeners.forEach((listener) => listener());
};

export const openShortlistSheet = () => {
  state = { isOpen: true };
  emitChange();
};

export const closeShortlistSheet = () => {
  state = { isOpen: false };
  emitChange();
};

export const getSnapshot = (): ShortlistSheetState => state;

export const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

// Uses useState + useEffect instead of useSyncExternalStore to avoid
// SSR crash (react-ssr-prepass doesn't support useSyncExternalStore).
export const useShortlistSheet = () => {
  const [current, setCurrent] = useState(getSnapshot);

  useEffect(() => {
    setCurrent(getSnapshot());
    return subscribe(() => setCurrent(getSnapshot()));
  }, []);

  return current;
};
